import React, { useState } from "react";
import { FaGoogle } from "react-icons/fa";
import { Link, useNavigate } from "react-router-dom";

const StepperForm = () => {
  const [step, setStep] = useState(1);
  const [formData, setFormData] = useState({
    gender: "",
    firstName: "",
    lastName: "",
    username: "",
    dateOfBirth: "",
    caste: "",
    maritalStatus: "",
    wantsToDisplayName: "",
    youAre: "",
    height: "",
    mobile: "",
    email: "",
    password: "",
    confirmPassword: "",
    profilePicture: "",
    qualification: "",
    income: "",
    look: "",
    occupation: "",
    country: "",
    state: "",
    address: "",
    whatsapp: "",
    phone: "",
    personalDetails: "",
    agreeToTerms: false,
  });

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData((prevData) => ({
      ...prevData,
      [name]: type === "checkbox" ? checked : value,
    }));
  };

  const handleNextStep = () => {
    if (step < 2) setStep(step + 1);
  };

  const handlePreviousStep = () => {
    if (step > 1) setStep(step - 1);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    const payload = { ...formData };
    // Send payload to backend, e.g., axios.post('/api/register', payload)
  };

  return (
    <div className="flex p-4 md:p-8 max-md:text-[12px]">
      <form
        onSubmit={handleSubmit}
        className="bg-white border border-red-300 rounded-lg p-8 max-md:p-4 w-full max-w-2xl"
      >
        <h2 className="text-center text-2xl font-bold mb-4">
          Create Your Account
        </h2>

        <div className="flex items-center my-4">
          <span className="flex-grow border-t border-gray-300"></span>
          <span className="mx-4 text-gray-500">OR</span>
          <span className="flex-grow border-t border-gray-300"></span>
        </div>

        <h3 className="text-center text-lg font-semibold mb-6">
          Basic Information
        </h3>

        {step === 1 && (
          <div className="grid grid-cols-2 gap-4 max-md:gap-2">
            <div>
              <label className="font-semibold max-md:text-[12px]">Gender</label>
              <select
                name="gender"
                value={formData.gender}
                onChange={handleChange}
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              >
                <option value="">Select</option>
                <option value="Male">Male</option>
                <option value="Female">Female</option>
              </select>
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                First Name
              </label>
              <input
                type="text"
                name="firstName"
                value={formData.firstName}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                Last Name
              </label>
              <input
                type="text"
                name="lastName"
                value={formData.lastName}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                Username
              </label>
              <input
                type="text"
                name="username"
                value={formData.username}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                Date of Birth
              </label>
              <input
                type="date"
                name="dateOfBirth"
                value={formData.dateOfBirth}
                onChange={handleChange}
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">Caste</label>
              <input
                type="text"
                name="caste"
                value={formData.caste}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                Marital Status
              </label>
              <select
                name="maritalStatus"
                value={formData.maritalStatus}
                onChange={handleChange}
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              >
                <option value="">Select</option>
                <option value="Single">Single</option>
                <option value="Married">Married</option>
              </select>
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                Display Name
              </label>
              <select
                name="wantsToDisplayName"
                value={formData.wantsToDisplayName}
                onChange={handleChange}
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                You Are
              </label>
              <select
                name="youAre"
                value={formData.youAre}
                onChange={handleChange}
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              >
                <option value="">Select</option>
                <option value="Student">Student</option>
                <option value="Professional">Professional</option>
              </select>
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                Your Height
              </label>
              <input
                type="text"
                name="height"
                value={formData.height}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                Mobile #
              </label>
              <input
                type="tel"
                name="mobile"
                value={formData.mobile}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">Email</label>
              <input
                type="email"
                name="email"
                value={formData.email}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                Password
              </label>
              <input
                type="password"
                name="password"
                value={formData.password}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                Confirm Password
              </label>
              <input
                type="password"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
          </div>
        )}

        {step === 2 && (
          <div className="grid grid-cols-2 gap-4 max-md:gap-2">
            <div>
              <label className="font-semibold max-md:text-[12px]">
                Profile Picture
              </label>
              <input
                type="file"
                name="profilePicture"
                onChange={handleChange}
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                Qualification
              </label>
              <input
                type="text"
                name="qualification"
                value={formData.qualification}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">Income</label>
              <input
                type="text"
                name="income"
                value={formData.income}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">Look</label>
              <input
                type="text"
                name="look"
                value={formData.look}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                Occupation
              </label>
              <input
                type="text"
                name="occupation"
                value={formData.occupation}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                Country
              </label>
              <select
                name="country"
                value={formData.country}
                onChange={handleChange}
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              >
                <option value="">Select</option>
                {/* Country options */}
              </select>
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">State</label>
              <select
                name="state"
                value={formData.state}
                onChange={handleChange}
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              >
                <option value="">Select</option>
                {/* State options */}
              </select>
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                Address
              </label>
              <input
                type="text"
                name="address"
                value={formData.address}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">
                WhatsApp
              </label>
              <select
                name="whatsapp"
                value={formData.whatsapp}
                onChange={handleChange}
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              >
                <option value="">Select</option>
                <option value="Yes">Yes</option>
                <option value="No">No</option>
              </select>
            </div>
            <div>
              <label className="font-semibold max-md:text-[12px]">Ph. No</label>
              <input
                type="tel"
                name="phone"
                value={formData.phone}
                onChange={handleChange}
                placeholder="Input text"
                className="w-full p-2 max-md:p-1 border border-gray-300 rounded-md"
              />
            </div>
            <div className="col-span-2 ">
              <label className="font-semibold max-md:text-[12px]">
                Personal Details
              </label>
              <textarea
                name="personalDetails"
                value={formData.personalDetails}
                onChange={handleChange}
                placeholder="Write about yourself"
                className="w-full p-2 max-md:p-1 border h-[120px] border-gray-300 rounded-md"
              />
            </div>
            <div className="col-span-2 flex items-center mt-4">
              <input
                type="checkbox"
                name="agreeToTerms"
                checked={formData.agreeToTerms}
                onChange={handleChange}
                className="mr-2"
              />
              <label className="font-semibold max-md:text-[12px]">
                I agree with the Terms of Services, Privacy Policy, and
                Disclaimer
              </label>
            </div>
          </div>
        )}

        {/* Step Navigation */}
        <div className="flex justify-between items-center mt-5">
          {step > 1 && (
            <button
              type="button"
              onClick={handlePreviousStep}
              className="text-[#730000] font-semibold"
            >
              Move Backward
            </button>
          )}
          {step < 2 ? (
            <button
              type="button"
              onClick={handleNextStep}
              className="text-[#730000] font-semibold"
            >
              Move Forward
            </button>
          ) : (
            <Link to="/">
              <button
                type="submit"
                className="bg-[#730000] text-white py-2 px-4 rounded-md font-semibold"
              >
                Register
              </button>
            </Link>
          )}
        </div>
      </form>
    </div>
  );
};

export default StepperForm;
